import CustomerSampleM from "@/views/customerSampleM/customerSampleM"

export default {
    path: '/customerSampleM',
    name: 'CustomerSampleM',
    component: CustomerSampleM,
  }


// WEBPACK FOOTER //
// ./src/router/customerSampleM/index.js